// Subconjunto habilitado del Catalogo 09 de SUNAT ("Tipo de Nota de Credito Electronica"):
// el sustento que se pide al anular un comprobante (ver OrderController::voidInvoice y
// CreditNoteReasonCatalog en el backend, con el mismo listado y orden). Se usa para generar
// la nota de credito interna del pedido (documento sin validez tributaria, solo para el
// historial de pedidos/comprobantes).
export const CREDIT_NOTE_REASONS = [
  { code: '01', label: 'Anulación de la operación' },
  { code: '02', label: 'Anulación por error en el RUC' },
  { code: '06', label: 'Devolución total' },
  { code: '03', label: 'Corrección por error en la descripción' },
  { code: '07', label: 'Devolución por ítem' },
];
